import React, { useEffect } from 'react';
import { Grid, TextField, Button, Link, LinearProgress, Avatar } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Link as LinkRouter, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { hangleLoginUser, hangleLogout } from '../../../redux/actions/user';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "5em",   
    [theme.breakpoints.down('sm')]: {
      marginTop: "1em",
    },
  },
  root2: {
    marginTop: "0em",   
    [theme.breakpoints.down('sm')]: {
      marginTop: "1em",
    },
  }
}));

function Login() {
  const classes = useStyles();
  let history = useHistory();

  const dispatch = useDispatch();
  const { loading, error } = useSelector( state => state.user );
  const { data: preCheckData } = useSelector( state => state.auth );

  useEffect(() => {
    // logout :)
    dispatch(hangleLogout());
  }, [dispatch]);  

  const { register, errors, handleSubmit } = useForm({
    // by setting validateCriteriaMode to 'all',
    // all validation errors for single field will display at once
    validateCriteriaMode: "all",
    mode: "onChange"
  });

  const goBack = () => {
    history.push('/auth/pre-check/');
  }

  const onSubmit = async data => {
    const {username, password} = data;
    dispatch(hangleLoginUser(username, password, history));    
  };

  return (    
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={preCheckData.university ? classes.root2 : classes.root}>                    

        {(preCheckData && preCheckData.university) && (
          <React.Fragment>
          <Grid item xs={12}>
            <div className="university-avatar" style={{margin: "auto"}}>
              <Avatar
                  color="#f1f1f1"
                  src={preCheckData.university.logo}
                  style={{margin: "auto"}}
                  disableSpinner={true}
                />
            </div>
          </Grid>
          <Grid item xs={12} style={{textAlign: "center"}}>
            <h3>{preCheckData.university.name}</h3>
          </Grid>
        </React.Fragment>
        )}

      <Grid item xs={12}>
        <TextField 
          name="username"
          label="your email"
          placeholder="email@example.com"
          variant="filled"
          fullWidth={true}
          value={preCheckData ? preCheckData.username : null}

          inputRef={register({ required: true, pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Invalid email address"
          }})}
          error={errors.username ? true : false}
          helperText={errors.username ? errors.username.message : null}
        />
      </Grid>

      <Grid item xs={12} style={ {marginTop: "1em"} }>
        <TextField 
          name="password"
          label="Password"
          type="password"
          placeholder="*****"
          variant="filled"
          fullWidth={true}

          inputRef={register({ required: true })}
          error={errors.password ? true : false}
          helperText={errors.password ? errors.password.message : null}
        />
      </Grid>
      
      <Grid item xs={12} style={ {marginTop: "0.5em"} }>
        <Link 
          component={LinkRouter}
          to={'/auth/forgot-password'}
          > 
          Forgot Your password ?
        </Link>
      </Grid>

      <Grid item xs={12} style={ {marginTop: "0.5em"} }>
        <div style={{position: "relative", width: "100%"}}> 
          <h4 style={ {top: "-1em", position: "abosulte", color: "#f44336", textAlign: "center" } }>{error}</h4>
        </div>
      </Grid>

      <Grid item xs={12} style={ {marginTop: "3em"} }>
        {loading && <LinearProgress /> }

        <Button
          style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1.3em", fontWeight: "bold"} }
          color="primary"
          disabled={loading}
          fullWidth={true}
          variant="contained"
          type="submit">
          Sign in
        </Button>                      
      </Grid>

      <Grid item xs={12} style={ {marginTop: "1em"} }>        
        <Button
          style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1em", fontWeight: "bold"} }          
          disabled={loading}
          fullWidth={true}
          variant="contained"
          onClick={goBack}
          type="button">
          Back
        </Button>                      
      </Grid>
    </form>
  )
}

export default Login;